// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__Kbm-f","title":"ClientCherryInfo_title__1sRxq","itemText":"ClientCherryInfo_itemText__VM82S"};